import { render } from "./DiffDates.vue?vue&type=template&id=5b132c06&scoped=true"
import script from "./DiffDates.vue?vue&type=script&lang=js"
export * from "./DiffDates.vue?vue&type=script&lang=js"

import "./DiffDates.vue?vue&type=style&index=0&id=5b132c06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b132c06"]])

export default __exports__